/**
 * Replace `{{varName}}` placeholders in a template with values from `vars`.
 * Unknown placeholders are left literal so the user can spot misspellings.
 */
export function mergeTemplate(template: string, vars: Record<string, string | number | undefined | null>): string {
	return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (full, key) => {
		const v = vars[key];
		return v == null ? full : String(v);
	});
}
